export enum BaseErrorCodesEnum {
  'error401' = 401,
  'error403' = 403,
  'error404' = 404,
}
